export const SITE = {
  name: "Renderwall Ltd",
  tagline: "Plastering & Rendering Projects",
  phone: "07545 963476",
  phoneRaw: "07545963476",
  email: "info@renderwall.co.uk",
  area: "Hampshire & the South East",
  logo:
    "https://customer-assets.emergentagent.com/job_company-web-218/artifacts/z3vdiuzn_Jun%2025%2C%202026%2C%2001_34_57%20PM.png",
};

export const NAV = [
  { label: "Services", href: "#services", id: "services" },
  { label: "Work", href: "#gallery", id: "gallery" },
  { label: "Why us", href: "#why", id: "why" },
  { label: "Reviews", href: "#reviews", id: "reviews" },
  { label: "FAQ", href: "#faq", id: "faq" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export const SERVICES = [
  {
    key: "rendering",
    title: "Rendering",
    blurb:
      "Silicone, monocouche, K-Rend & traditional sand-cement renders. Weatherproof, low-maintenance finishes that lift any property.",
    image:
      "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg",
    span: "md:col-span-8 md:row-span-2",
  },
  {
    key: "plastering",
    title: "Plastering",
    blurb:
      "Skim, float & set, and full re-plastering. A flawless surface, ready for paint, on every domestic and commercial job.",
    image: "https://images.pexels.com/photos/5691622/pexels-photo-5691622.jpeg",
    span: "md:col-span-4",
  },
  {
    key: "drylining",
    title: "Drylining",
    blurb:
      "Metal stud partitions, MF ceilings, plasterboarding and tape & joint. Built to programme, finished to spec.",
    image: "https://images.pexels.com/photos/6474313/pexels-photo-6474313.jpeg",
    span: "md:col-span-4",
  },
];

export const STATS = [
  { value: "20+", label: "Years on the tools" },
  { value: "500+", label: "Projects completed" },
  { value: "100%", label: "Fully insured" },
  { value: "48h", label: "Quote turnaround" },
];

export const REASONS = [
  {
    title: "Tradesmen, not salesmen",
    body: "You speak to the people doing the work. Honest advice, fair pricing, no hard sells.",
  },
  {
    title: "Domestic & commercial",
    body: "From a single feature wall to multi-plot new builds — same care, same finish.",
  },
  {
    title: "Clean sites, on time",
    body: "Sheeted, swept and respectful of your home or site. We turn up when we say we will.",
  },
  {
    title: "Built to last",
    body: "Specifications matched to the substrate and the weather. Finishes that hold up.",
  },
];

export const GALLERY = [
  {
    src: "https://images.pexels.com/photos/7031581/pexels-photo-7031581.jpeg",
    title: "Coastal silicone render",
    tag: "Rendering",
    type: "Domestic",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_company-web-218/artifacts/asypezdi_Skimming%20up%20close.webp",
    title: "Skim — open plan extension",
    tag: "Plastering",
    type: "Domestic",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_company-web-218/artifacts/ynk3ahm2_Screenshot_28-6-2026_183950_www.google.com.jpeg",
    title: "Traditional hand-finished render",
    tag: "Rendering",
    type: "Domestic",
  },
  {
    src: "https://images.pexels.com/photos/6474313/pexels-photo-6474313.jpeg",
    title: "MF ceiling — office fit-out",
    tag: "Drylining",
    type: "Commercial",
  },
  {
    src: "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg",
    title: "K-Rend new build",
    tag: "Rendering",
    type: "Commercial",
  },
  {
    src: "https://images.pexels.com/photos/5691622/pexels-photo-5691622.jpeg",
    title: "Two-coat plaster, terraced refurb",
    tag: "Plastering",
    type: "Domestic",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Luke and the team rendered the entire front of our 1930s semi. The finish is faultless and the site was spotless every evening.",
    author: "Hannah W.",
    location: "Winchester",
  },
  {
    quote:
      "Used Renderwall for a 14-plot site. Hit every programme date and the QA on the plasterboarding was the best we've had in years.",
    author: "Mark D.",
    location: "Site Manager, Southampton",
  },
  {
    quote:
      "Honest quote, fair price, beautiful skim. Already booked them in for the next room.",
    author: "Priya S.",
    location: "Basingstoke",
  },
];

export const FAQS = [
  {
    q: "Do you cover my area?",
    a: "Our main coverage is Hampshire, but we regularly work across the South East — Surrey, West Sussex, Berkshire and Dorset. Drop us your postcode and we'll confirm.",
  },
  {
    q: "How much does rendering or plastering cost?",
    a: "Every job is different — substrate, access and finish all change the price. Send us a few details or photos and we'll come back within 48 hours with a clear, itemised quote.",
  },
  {
    q: "Are you insured?",
    a: "Yes. Renderwall Ltd carries full public liability insurance. Documentation is available on request before any job starts.",
  },
  {
    q: "How long will my project take?",
    a: "A typical room skim is one day; a full house render is usually 1–2 weeks weather depending. We'll give you a firm programme with your quote.",
  },
  {
    q: "Do you handle commercial work?",
    a: "Absolutely. We run dedicated commercial teams for fit-outs, new builds and refurbishments, including drylining, taping and finishing to spec.",
  },
];
